import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EventTreeService } from 'app/Shared/Component/event-tree/event-tree.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { DataService } from 'app/Shared/Services/data.service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { default as _  } from 'lodash';
import { MessageService, ConfirmationService } from 'primeng/api';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinraInquiryServiceService {
  CATFieldTypesArrayList: any = [];
  defaultCATEvents: any = [];
  LastExecutionInquiryDate: any[] = [];
  isLoadingAddingFinraInquiry: boolean = false;
  isGenerateFinraInquiry: boolean = false;
  disableRunCompReportButton: boolean = true;
  DefaultFilterArray: any = [];
  InquiryFilterArray: any = [];
  Limit: any = { 'Start': '0', 'End': '20' };
  selectedInquiryRowObj: any = new Object();
  modifiednquiryRowObj: any = new Object();
  activeInquiry: any = new Object();
  userAction: any = "";

  constructor(
    private readonly gridService: GridService,
    public constantService: ConstantService,
    public dataService: DataService,
    public eventTreeService: EventTreeService,
    public userService: UserService,
    private readonly emitterService: EmitterService,
    private readonly messageService: MessageService,
    public confirmationService: ConfirmationService,
    private readonly urlsService: UrlsService,
    private readonly sharedHttpClientService: SharedHttpClientService,
  ) {
    this.getLastReportDate();
    this.CATFieldTypesArrayList = this.userService.getDropDownList('type');
    this.defaultCATEvents = ["MENO", "MEOA", "MLNO", "MLOA", "MONO", "MOOA", "MEOM", "MOOM", "MLOM"];
  }

  getLastReportDate() {
    let todayDate: any = new Date();
    this.LastExecutionInquiryDate = [];

    this.LastExecutionInquiryDate.push(todayDate); //Fromdate
    this.LastExecutionInquiryDate.push(todayDate); //Todate
  }

  defaultFilter() {
    this.getLastReportDate();
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'inquiryDate', 'filterby': 'IS', 'values': this.LastExecutionInquiryDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      {
        'isdefault': 'true', 'label': 'Inquiry Status', 'columnname': 'status', 'filterby': 'IN', 'values': [], 'time': '',
        'datatype': 'Array', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect',
        'dropdownvalue': this.constantService["inquirySelectionValues"][0]["inquiryFields"]["status"] },
      { 'isdefault': 'true', 'label': 'Inquiry Tag', 'columnname': 'tag', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Inquiry Requestor', 'columnname': 'inquiryRequestor', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': 'YES', dropdowntype: 'singleselect', 'dropdownvalue': this.constantService["inquirySelectionValues"][0]["inquiryFields"]["inquiryRequestorFilters"] }
    ];
  }

  InquiryFilter() {
    this.InquiryFilterArray = [
      { 'isdefault': 'true', 'label': 'Transaction Date', 'columnname': 'eventTimestamp', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Inquiry Tag (*)', 'columnname': 'tag', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }, 
      { 'isdefault': 'true', 'label': 'Inquiry Requestor (*)', 'columnname': 'inquiryRequestor', 'filterby': 'IS', 'values': 'Other', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'singleSelect', 'dropdownvalue': this.constantService["inquirySelectionValues"][0]["inquiryFields"]["inquiryRequestorFilters"] },
      { 'isdefault': 'true', 'label': 'Inquiry Status (*)', 'columnname': 'status', 'filterby': 'IS', 'values': this.constantService["inquirySelectionValues"][0]["inquiryFields"]["status"][0], 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'singleSelect', 'dropdownvalue': this.constantService["inquirySelectionValues"][0]["inquiryFields"]["inquiryStatusFilters"] },
      { 'isdefault': 'true', 'label': 'Inquiry Date (*)', 'columnname': 'inquiryDate', 'filterby': '', 'values': this.LastExecutionInquiryDate[0], 'time': '', 'datatype': 'Date', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Type', 'columnname': 'type', 'filterby': 'IS', 'values': this.defaultCATEvents, 'time': '', 'datatype': 'skip', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect', 'dropdownvalue': this.CATFieldTypesArrayList },
      {
        'isdefault': 'true', 'label': 'Rsms Status', 'columnname': 'rsmsStatus', 'filterby': 'IN', 'values': [],
        'time': '', 'datatype': 'Array', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect',
        'dropdownvalue': this.constantService.rsmsStatusDropDwn,
      },
      { 'isdefault': 'true', 'label': 'Order ID', 'columnname': 'orderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Tape TradeID', 'columnname': 'TapeTradeID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Firm Designated ID', 'columnname': 'firmDesignatedID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];
  }

  resetInquiryFilter() {
    let initialInquiryFilter = [
      { 'isdefault': 'true', 'label': 'Transaction Date', 'columnname': 'eventTimestamp', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Inquiry Tag (*)', 'columnname': 'tag', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }, 
      { 'isdefault': 'true', 'label': 'Inquiry Requestor (*)', 'columnname': 'inquiryRequestor', 'filterby': 'IS', 'values': 'Other', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'singleSelect', 'dropdownvalue': this.constantService["inquirySelectionValues"][0]["inquiryFields"]["inquiryRequestorFilters"] },
      { 'isdefault': 'true', 'label': 'Inquiry Status (*)', 'columnname': 'status', 'filterby': 'IS', 'values': this.constantService["inquirySelectionValues"][0]["inquiryFields"]["status"][0], 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'singleSelect', 'dropdownvalue': this.constantService["inquirySelectionValues"][0]["inquiryFields"]["inquiryStatusFilters"] },
      { 'isdefault': 'true', 'label': 'Inquiry Date (*)', 'columnname': 'inquiryDate', 'filterby': '', 'values': this.LastExecutionInquiryDate[0], 'time': '', 'datatype': 'Date', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Type', 'columnname': 'type', 'filterby': 'IS', 'values': this.defaultCATEvents, 'time': '', 'datatype': 'skip', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect', 'dropdownvalue': this.CATFieldTypesArrayList },
      {
        'isdefault': 'true', 'label': 'Rsms Status', 'columnname': 'rsmsStatus', 'filterby': 'IN', 'values': [],
        'time': '', 'datatype': 'Array', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect',
        'dropdownvalue': this.constantService.rsmsStatusDropDwn,
      },
      { 'isdefault': 'true', 'label': 'Order ID', 'columnname': 'orderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Tape TradeID', 'columnname': 'TapeTradeID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Firm Designated ID', 'columnname': 'firmDesignatedID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];

    this.InquiryFilterArray = [...initialInquiryFilter];
  }

  addInquiry(tempFilterData: any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.saveInquiry), this.getAPIPayload(tempFilterData))
      .pipe(map((response: Response) => {
        return response;
      }));
  }

  getAPIPayload(tempFilterData: any) {
    let inquiryFilterDetail =  structuredClone(tempFilterData); // Clone Default Filter Array for Storing in DB Column
    this.getUpdatedFilterDetail(inquiryFilterDetail);

    const eventTypeList = this.gridService.getEventsList(tempFilterData, 'Type');

    const filterData = JSON.parse(JSON.stringify(tempFilterData));
    filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));

    let inquiryData = filterData.splice(1, 4);

    let inquiryObj: any = {
      tag: inquiryData[0].values,
      inquiryRequestor: inquiryData[1].values,
      fileId: 0,
      inquiryDate: this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(inquiryData[3].values))),
      status: inquiryData[2].values
    };

    // Add InquiryID and fileID at the time of Edit Inquiry Detail
    if((Object.keys(this.modifiednquiryRowObj).length > 0)) {
      Object.assign(inquiryObj, { inquiryId: this.modifiednquiryRowObj.inquiryId, fileId: this.modifiednquiryRowObj.fileId });
    }

    let payload: any = {
      "CATReporterIMID": this.userService.getActiveMPID(),
      "inquiryDetails": inquiryObj,
      "data": JSON.parse(JSON.stringify(filterData)),
      "userAction": (Object.keys(this.modifiednquiryRowObj).length > 0 ? "UpdateInquiry" : "AddNewInquiry"),
      "eventType": eventTypeList,
      "inquiryData": inquiryData,
      "inquiryFilterDetail": JSON.stringify(inquiryFilterDetail),
      "user": this.userService.getUserName(),
      "userName": this.userService.getUserFirstName()
    };

    return payload;
  }

  getUpdatedFilterDetail(filterInquiryDetail: any) {
    if(filterInquiryDetail.length > 0) {
      for(let i=0; i < filterInquiryDetail.length; i++) {
        if(_.includes(["Date", "DateRange"], filterInquiryDetail[i].datatype)) {
          if(Array.isArray(filterInquiryDetail[i].values)) {
            filterInquiryDetail[i].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterInquiryDetail[i].values[0])));
            filterInquiryDetail[i].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterInquiryDetail[i].values[1])));
          } else {
            filterInquiryDetail[i].values = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterInquiryDetail[i].values)));
          }
        }
      }
    }
  }

  fetchInquiryResult(InquiryId: number) {
    let APIParams = {
      CATReporterIMID: this.userService.getActiveMPID(),
      user: this.userService.getUserName(),
      userName: this.userService.getUserFirstName(),
      inquiryIds: InquiryId.toString()
    };

    // Fetch Inquiry Initiation Acknowledgment Message
    this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_WARN, summary: this.constantService.MESSAGE_SUMMARY_WARN, detail: 'Fethcing Result has been started and may take time, result will display once Inquiry status will be completed, Please reload screen after some time.' });

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.fetchInquiryResult
      ), APIParams)
      .subscribe({
        next: (res:any) => {
          if(res.status === false) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: res.message });
          } else if (res.status === true) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: 'Fethcing Results may take time it will display once Inquiry status will be completed' });
          }
      }, error: (err: HttpErrorResponse) => {

      }
    });
  }

  /* Check Inquiry Result Execution Privilege */
  getInqiryExecutableStatus() {
    let ApiPayload: any = {
      "CATReporterIMID": this.userService.getActiveMPID(),
      "user": this.userService.getUserName(),
      "userName": this.userService.getUserFirstName()
    };

    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.getInquiryExecutionPrivilege), ApiPayload)
      .pipe(map((response: Response) => {
        return response;
      }));
  }

}